import { extendedArea } from '@bpd-library/utilities';
import { TranslateOptions } from '@utilities/hooks/use-translate.types';
import { translateEnumeration } from '@utilities/translate-enumeration';

import { ExtendedAreaSubscriptionState } from '../types';

export const AREA_NAME = 'areaName';
export const PROJECT_NAMES = 'projectNames';

export const SUBSCRIBED_PROJECT_PHASES_COUNT = 'projectsSubscribedCount';
export const AVAILABLE_PROJECT_PHASES_COUNT = 'projectsAvailableCount';
export const SELECTED_PROJECT_PHASES_COUNT = 'projectsSelectedCount';

export const SUBSCRIBED_PROPERTY_TYPES_COUNT = 'propertiesSubscribedCount';
export const AVAILABLE_PROPERTY_TYPES_COUNT = 'propertiesAvailableCount';
export const SELECTED_PROPERTY_TYPES_COUNT = 'propertiesSelectedCount';

const translationOptions: TranslateOptions = {
    replace: [],
    plurality: [],
};

export const getTranslationOptions = () => translationOptions;

export const updateTranslationOptions = (newTranslationOptions: TranslateOptions) => {
    if (newTranslationOptions.replace?.length) {
        if (translationOptions.replace?.length) {
            const validOldReplacements = translationOptions.replace.filter(({ id: idOld }) => {
                return !newTranslationOptions.replace?.find(({ id: idNew }) => idOld === idNew);
            });
            translationOptions.replace = [
                ...validOldReplacements,
                ...newTranslationOptions.replace,
            ];
        } else {
            translationOptions.replace = newTranslationOptions.replace;
        }
    }
    if (newTranslationOptions.plurality?.length) {
        if (translationOptions.plurality?.length) {
            const validOldPluralities = translationOptions.plurality.filter(({ id: idOld }) => {
                return !newTranslationOptions.plurality?.find(({ id: idNew }) => idOld === idNew);
            });
            translationOptions.plurality = [
                ...validOldPluralities,
                ...newTranslationOptions.plurality,
            ];
        } else {
            translationOptions.plurality = newTranslationOptions.plurality;
        }
    }
    return translationOptions;
};

export const updateAreaSubscriptionTranslationOptions = async ({
    subscribedProjectIds,
    availableProjectIds,
}: ExtendedAreaSubscriptionState) => {
    const {
        areaProject: { name: areaProjectName },
        projectPhases,
    } = await extendedArea.getData(window.__ENVIRONMENT_DETAILS__.areaId);

    const stagedTranslateOptions: TranslateOptions = {
        replace: [
            { id: AREA_NAME, value: areaProjectName! },
            { id: SELECTED_PROJECT_PHASES_COUNT, value: '0' },
        ],
        plurality: [
            { id: SELECTED_PROJECT_PHASES_COUNT, value: 0, total: availableProjectIds?.length },
        ],
    };

    if (subscribedProjectIds) {
        const subscribedProjectNames = subscribedProjectIds.map((projectId) => {
            return projectPhases.find(({ id }) => id === projectId)?.name || '';
        });
        const subscribedProjectsEnumerated = await translateEnumeration(subscribedProjectNames, {
            cutoff: 3,
        });

        stagedTranslateOptions.replace?.push(
            { id: PROJECT_NAMES, value: subscribedProjectsEnumerated },
            { id: SUBSCRIBED_PROJECT_PHASES_COUNT, value: `${subscribedProjectIds.length}` },
        );
        stagedTranslateOptions.plurality?.push({
            id: SUBSCRIBED_PROJECT_PHASES_COUNT,
            value: subscribedProjectIds.length,
        });
    }

    if (availableProjectIds) {
        stagedTranslateOptions.replace?.push({
            id: AVAILABLE_PROJECT_PHASES_COUNT,
            value: `${availableProjectIds.length}`,
        });
        stagedTranslateOptions.plurality?.push({
            id: AVAILABLE_PROJECT_PHASES_COUNT,
            value: availableProjectIds.length,
        });
    }

    updateTranslationOptions(stagedTranslateOptions);
};
